import fetchJson from '../../common/rest/fetch-json.tsx';
import { getVersionEndpointUrl } from '../../common/rest/index.tsx';
import type { Version as RestVersion } from '../../common/rest/types.tsx';

export const releaseVersion = (baseUrl: string, version: RestVersion): Promise<RestVersion> => {
	const url = getVersionEndpointUrl(baseUrl, version.id);
	return fetchJson(url, {
		method: 'put',
		body: JSON.stringify({
			...version,
		}),
	});
};
